// Single source of truth for Wheel visibility options (Public / Private / Hidden).
//
// WHY THIS FILE EXISTS
// Visibility was declared inline in at least two places (the Create-Wheel wizard's
// WheelVisibility step and the Segment Builder's Privacy tab), which let them drift:
// the wizard hid its explanations behind hover-only tooltips while the Privacy tab
// used a different, longer wording. Both now read this list, so the three options,
// their copy and their icons can never disagree again.
//
// ICONS
// `icon` is a key into ASSETS.segmentEditor, NOT a bespoke glyph. The app already
// ships one canonical icon per visibility state and uses it on every Wheel card and
// in the WheelStatus chip, so the picker now shows the SAME mark the user will see
// on the card once the Wheel exists. An earlier draft of this component invented a
// new globe/link/eye-off line-art set, which would have given one concept two
// different icon vocabularies in the same product.
//
// RENAME SAFETY
// A Public / Unlisted / Private rename is under consideration (see NEEDS-GORDON.md).
// `value` is the wire format and MUST NOT change — the backend contract is
// 1 = Public, 2 = Private (URL-only), 3 = Hidden (owner-only). `key` is the stable
// internal identifier used by code. Only `label` is user-facing prose, so a rename is
// a one-line edit here and nothing else in the app has to move. The descriptions are
// written to describe the BEHAVIOR, not to restate the label, so they survive a rename
// unchanged ("Visible only by shared link" stays true whether the option is called
// "Private" or "Unlisted").

export const WHEEL_VISIBILITY = {
  PUBLIC: 1,
  PRIVATE: 2,
  HIDDEN: 3,
};

export const WHEEL_VISIBILITY_OPTIONS = [
  {
    value: WHEEL_VISIBILITY.PUBLIC,
    key: "PUBLIC",
    label: "Public",
    description: "Visible to everyone",
    icon: "PublicWheel",
  },
  {
    value: WHEEL_VISIBILITY.PRIVATE,
    key: "PRIVATE",
    label: "Private",
    description: "Visible only by shared link",
    icon: "PrivateWheel",
  },
  {
    value: WHEEL_VISIBILITY.HIDDEN,
    key: "HIDDEN",
    label: "Hidden",
    description: "Visible only to me",
    icon: "Incognito",
  },
];

// Convenience lookup for surfaces that only need to name the current setting
// (menus, status chips, toasts) without rendering the whole picker.
export const getWheelVisibilityOption = (value) =>
  WHEEL_VISIBILITY_OPTIONS.find(
    (option) => String(option.value) === String(value),
  ) || null;
